import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import React from 'react'
import {
    Poppins_600SemiBold
} from '@expo-google-fonts/poppins';
import { useFonts } from 'expo-font';


type Props = {
    label: string,
    onClick?: () => void
}

export default function ActionButton(props: Props) {

    const [fontsLoaded] = useFonts({
        Poppins_600SemiBold,

    });

    if (!fontsLoaded) return null;

    return (
        <View style={styles.container}>
            <TouchableOpacity style={styles.button} onPress={props.onClick}>
                <Text style={styles.buttonText}>{props.label}</Text>
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
    },
    button: {
        backgroundColor: '#0E64D2',
        padding: 12,
        borderRadius: 5
    },
    buttonText: {
        color: 'white',
        fontSize: 16,
        textAlign: 'center',
        fontFamily: "Poppins_600SemiBold"
    },
})